import { RoleOption } from '../types/enums/Role';
const rolePriority = [
    RoleOption.PlatformAdmin,
    RoleOption.OrganisationManager,
    RoleOption.TeamManager,
    RoleOption.Inspector,
];
export const roleDetails = {
    [RoleOption.Inspector]: {
        name: 'Inspector',
        value: RoleOption.Inspector,
    },
    [RoleOption.TeamManager]: {
        name: 'Team Manager',
        value: RoleOption.TeamManager,
    },
    [RoleOption.OrganisationManager]: {
        name: 'Organisation Manager',
        value: RoleOption.OrganisationManager,
    },
    [RoleOption.PlatformAdmin]: {
        name: 'Platform Admin',
        value: RoleOption.PlatformAdmin,
    },
};
export const getRoleFromOption = (option) => {
    const role = roleDetails?.[option];
    if (!role)
        throw new Error('Role option not available');
    return role;
};
export const getMaxRole = (roles) => {
    const highestRole = rolePriority.find((role) => roles.includes(role));
    return highestRole ? roleDetails?.[highestRole] : undefined;
};
export const hasHigherRole = (user1Roles, user2Roles) => {
    const user1Role = getMaxRole(user1Roles.map((role) => role.id))?.value;
    const user2Role = getMaxRole(user2Roles.map((role) => role.id))?.value;
    if (!user1Role || !user2Role)
        return false;
    const role1Index = rolePriority.indexOf(user1Role);
    const role2Index = rolePriority.indexOf(user2Role);
    return role1Index <= role2Index;
};
